<template>
	<div class="cruisechoice">
		<back-to></back-to>
		<section class="choiceDate">
			<van-calendar title="日期选择" :formatter="formatter" :poppable="false" :show-confirm="false"
				class="choiceDate-calendar" @select="select" :default-date="defaultDate" />
		</section>
		<!-- 类型和数量 -->
		<section class="choiceNum">
			<div class="choiceNum-sku">
				<h2>产品类型</h2>
				<span v-for="(item, index) in cabinsList" :class="index == selectIndex?'skuActive':''"
					@click="sku(index)">
					<p>{{item.cabinName}}</p>
					<font v-if="item.allow_spell == false">整间</font>
					<font v-if="item.allow_spell">拼住</font>
					<img v-if="index == selectIndex" src="https://m.sweetour.com/img/wifi/wifi-active.png" alt="">
				</span>
			</div>
			<div class="choiceNum-num">
				<h2>购买数量</h2>
				<div class="choiceNum-num-n">
					<span>成人（￥{{price}} 余{{stock-num}}）</span>
					<span>
						<p class="btn btn-minus" @click="sub"></p>
						<font>{{num}}</font>
						<p class="btn btn-plus" @click="add"></p>
					</span>
				</div>
			</div>
		</section>
		<!-- 底部 -->
		<section class="choiceBtn">
			<div class="choiceBtn-l">
				<p>价格:</p>
				<font>￥{{total}}</font>
			</div>
			<div class="choiceBtn-r" v-if="stock > 0" @click="goto">填写信息</div>
			<div class="choiceBtn-r" v-else style='background: #e5e4e3;'>已售罄</div>
		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	import {
		Dialog
	} from 'vant'
	export default {
		name: 'cruisechoice',
		components: {
			BackTo
		},
		data() {
			return {
				orderData:[],
				listTickets: [],
				proTypeID: 0,
				selectIndex: 0,
				num: 1,
				price: 0,
				total: 0,
				time: '',
				stock: 1,
				defaultDate: null,
				cabinsList: [],
				tour_no:""
			}
		},
		created() {
			this.id = this.$route.query.id
			this.image = this.$route.query.image
		},
		mounted() {
			this.setScheduleint()
		},
		methods: {
			goto() {
				if (this.time == '') {
					Dialog.alert({
						message: '请选择套餐日期',
					}).then(() => {});
					return false
				}

				let orderParam = {}
				orderParam.proName = this.cabinsList[this.selectIndex].cabinName
				orderParam.number = this.num
				orderParam.payMoney = this.total
				orderParam.image = this.image
				orderParam.productName = this.tour_no
				orderParam.departureDate = this.time
				orderParam.data = this.orderData
				orderParam.selectIndex = this.selectIndex
				orderParam.id = this.$route.query.id
				
				this.$router.push({
					path: '/cruiseOrder',
					query: {
						orderParam: JSON.stringify(orderParam)
					}
				})
			},
			sub() {
				if (this.cabinsList[this.selectIndex].allow_spell) {
					if (this.num < 1) {
						this.num = 0
						this.total = 0
					} else {
						this.num = this.num - 1
						this.total = this.num * parseFloat(this.price)
					}
				} else {
					if (this.num <= this.cabinsList[this.selectIndex].max_stay) {
						this.num = this.cabinsList[this.selectIndex].max_stay
						this.total = this.num * parseFloat(this.price)
					} else {
						this.num = this.num - this.cabinsList[this.selectIndex].max_stay
						this.total = this.num * parseFloat(this.price)
					}
				}

			},
			add() {
				if (this.cabinsList[this.selectIndex].allow_spell) {
					if (this.num >= this.stock) {
						this.num = this.stock
					} else {
						this.num = this.num + 1
						this.total = this.num * parseFloat(this.price)
					}
				} else {
					if (this.num >= this.stock) {
						this.num = this.stock - Math.floor(this.stock % this.cabinsList[this.selectIndex].max_stay)
						this.total = this.num * parseFloat(this.price)
					} else {
						this.num = this.num + this.cabinsList[this.selectIndex].max_stay
						this.total = this.num * parseFloat(this.price)
					}
				}
			},
			select(e) {
				var list = this.listTickets
				var time = new Date(e).getTime() / 1000
				var data = list.filter(item => item.stamp == time)
				if (data.length > 0) {
					this.time = time
					this.cabinsList = data[0].cabins
					this.tour_no = data[0].tour_no
					this.price = data[0].minPrice
					this.stock = data[0].total_number_stock
					this.num = data[0].cabins[this.selectIndex].max_stay
					this.total = this.num * parseFloat(this.price)
					this.orderData = data[0]
				} else {
					Dialog.alert({
						message: '暂无计划安排，请重新选择日期',
					}).then(() => {
						this.total = 0
					});

				}

			},
			setScheduleint() {
				this.$get(
					this.$domainUrl + '/ShipApp/GetShipDate?id=' + this.$route.query.id, {}
				).then(res => {
					console.log(res)
					this.listTickets = res.data.prices
					this.defaultDate = new Date(res.data.prices[0].stamp * 1000)
					this.time = res.data.prices[0].stamp
					this.cabinsList = res.data.prices[0].cabins
					this.price = res.data.prices[0].minPrice
					this.tour_no = res.data.prices[0].tour_no
					this.stock = res.data.prices[0].total_number_stock
					this.num = res.data.prices[0].cabins[this.selectIndex].max_stay
					this.total = this.num * parseFloat(this.price)
					this.orderData = res.data.prices[0]
				})
			},
			formatter(day) {
				const year = day.date.getFullYear();
				const month = day.date.getMonth() + 1;
				const date = day.date.getDate();
				if (this.listTickets.length > 0) {
					var list = this.listTickets
					list.forEach((e, index) => {
						var currentObj = new Date(e.stamp * 1000)
						if (year === currentObj.getFullYear()) {
							if (month === (currentObj.getMonth() + 1)) {
								if (date === currentObj.getDate()) {
									day.topInfo = currentObj.getDate()
									day.text = '余' + e.total_number_stock
									day.bottomInfo = '￥' + e.minPrice
								}
							}
						}
					});
				}
				return day
			}

		}
	}
</script>

<style>
	.cruisechoice .choiceDate-calendar {
		height: 780px;
	}

	.cruisechoice .van-calendar__header-title {
		text-align: left;
		font-size: 28px;
		color: #333;
		height: 80px;
		line-height: 80px;
		margin-left: 32px;
		font-weight: bold;
	}

	.cruisechoice .van-calendar__header-subtitle {
		background-color: #fafafa;
	}

	.cruisechoice .van-calendar__weekdays {
		background-color: #ff8a00;
		color: #fff;
	}

	.cruisechoice .van-calendar__selected-day {
		background-color: rgba(255, 109, 0, .3);
		color: #ff6d00;
		justify-content: flex-end;
		text-align: right;
	}

	.cruisechoice .van-calendar__bottom-info {
		color: #ff6d00;
		bottom: 5px
	}

	.cruisechoice .van-calendar__day {
		transform: scale(0.8);
		font-size: 18px;
		color: #999;
		justify-content: flex-end;
		text-align: right;
		height: 106px;
	}

	.cruisechoice .van-calendar__top-info {
		font-size: 34px;
		color: #333;
		transform: scale(1);
		top: 5px
	}


	.choiceNum {
		width: 100%;
		padding: 10px 42px;
		box-sizing: border-box;
		padding-bottom: 160px;
	}

	.choiceNum h2 {
		font-size: 33px;
		font-weight: normal;
	}

	.choiceNum-sku span {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		color: #333;
		background: #f9f9f9;
		border-radius: 8px;
		margin: 35px 0;
		font-size: 28px;
		height: 90px;
	}

	.choiceNum-sku span p {
		padding-left: 19px;
	}

	.choiceNum-sku span font {
		font-size: 22px;
		padding: 8px 15px;
		border-radius: 5px;
		margin-left: 20px;
		background: #FFF6EE;
		color: #666666;
		border: 1px solid #C1C1C1;

	}

	.choiceNum-sku span img {
		width: 42px;
		height: 42px;
		margin-top: auto;
		margin-left: auto;
	}

	.skuActive {
		border: 1px solid #ff9240;
	}

	.skuActive font {
		color: #FF7A09 !important;
		border: 1px solid #FFC08A !important;
	}

	.skuActive p {
		color: #ff9240;
	}

	.choiceNum-num-n {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		margin-top: 40px;
	}

	.choiceNum-num-n span {
		display: flex;
		align-items: center;
	}

	.choiceNum-num-n font {
		display: inline-block;
		background: #fef6f1 no-repeat center;
		width: 84px;
		height: 45px;
		line-height: 45px;
		color: #666;
		text-align: center;
		font-size: 28px;
	}

	.btn {
		display: inline-block;
		background: #FFF no-repeat center;
		width: 64px;
		height: 45px;
		border-radius: 2px;
		box-shadow: 0 1px rgba(100, 100, 100, .1);
		color: #666;
		transition: color .2s, background-color .2s;

	}

	.btn-minus {
		background-image: linear-gradient(to top, currentColor, currentColor);
		height: 45px;
		background-size: 25px 4px;
	}

	.btn-plus {
		background-image: linear-gradient(to top, currentColor, currentColor), linear-gradient(to top, currentColor, currentColor);
		background-size: 25px 4px, 4px 25px;
	}

	.choiceBtn {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 96px;
		border-top: 1px solid #e5e4e3;
		background-color: #fff;
	}

	.choiceBtn div {
		height: 96px;
		display: flex;
		align-items: center;
	}

	.choiceBtn-r {
		width: 286px;
		background: #ff6d00;
		font-size: 36px;
		color: #fff;
		border: 0;
		justify-content: center;
	}

	.choiceBtn-l {
		color: #ff6d00;
		font-size: 48px;
		display: inline-block;
		padding-left: 28px;
		box-sizing: border-box;
	}

	.choiceBtn-l p {
		font-size: 28px;
		color: #333;
		margin-top: 12px;
		padding-right: 7px;
	}
</style>
